import { render, staticRenderFns } from "./swordForm.vue?vue&type=template&id=5e1f0c42&scoped=true&"
import script from "./swordForm.vue?vue&type=script&lang=js&"
export * from "./swordForm.vue?vue&type=script&lang=js&"
import style0 from "./swordForm.vue?vue&type=style&index=0&id=5e1f0c42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1f0c42",
  null
  
)

component.options.__file = "swordForm.vue"
export default component.exports